<template>
  <v-dialog
    v-model="dialogVisible"
    fullscreen
    hide-overlay
    :retain-focus="false"
    persistent
    transition="dialog-bottom-transition">
     <!-- Boton de lapiz -->
     <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="btnDetails"
          v-bind="attrs"
          v-on="on" 
          icon    
          x-large
          dark
          text
          @click="dialogVisible = true"
          style="background-color: transparent;"
          >
            <v-icon color="primary">mdi-border-color</v-icon>
        </v-btn>
      </template>
    <v-card>
      <v-toolbar 
        dark 
        color="secondary">
        <v-btn 
          icon 
          dark 
          class="btn btn-primary" 
          @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>{{ $t('product.label.detailProduct.title') }}</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="accent"></v-tabs-slider>

            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template> 

      </v-toolbar>

      <v-tabs-items v-model="tab" class="container mt-5">
              
        <v-tab-item>
          <div class="container mt-4">
            <formDetailProduct
            :product="productProps"
            />
          </div>
        </v-tab-item>

      </v-tabs-items>
      
    </v-card>
  </v-dialog>
</template>

<script>

import formDetailProduct from "@/views/products/pages/detail_product/components/form_detail_products_component.vue"
import  EventBus  from '@/utils/event_bus.js'; 

export default {

  name: "detailProduct",
  components: {
    formDetailProduct
  },
  props: {
    productProps: {
      required: true
    },
  },
  data() {
    return {
      dialogVisible: false,
      tab: null,    
      items: [
        this.$t('label.tab')
      ],
    };
  },

  mounted() {
    if (this.productProps) {
      this.formData = { ...this.productProps };
    }

    EventBus.$on('form-submit-products', async () => {
      await this.closeDialog();
      this.$store.commit('RESET_STATE');
        window.location.reload();  
    })

    EventBus.$on('reload-update-product', async () => {
      await this.closeDialog();
      this.$store.commit('RESET_STATE');
        window.location.reload();  
    })

  },
  
  methods: {    
    closeDialog() {
      this.dialogVisible = false; 
      window.location.reload();  
      
    }
  },

  
};
</script>

<style lang="css" scoped>

.btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 12px;
  }
</style>
